import { useQuery } from '@apollo/client';
import DEFAULT_OPERATIONS from './collections.gql';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
/**
 *
 * @param {*} props.operations GraphQL operations used by talons
 */

export var useCollections = function useCollections() {
  var _categoryData$categor, _categoryData$categor2, _categoryData$categor3, _categoryData$categor4, _data$collections;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _mergeOperations = mergeOperations(DEFAULT_OPERATIONS, props.operations),
      getCollections = _mergeOperations.getCollections,
      getCmsPageMeta = _mergeOperations.getCmsPageMeta;

  var _useQuery = useQuery(getCollections, {
    variables: {
      pageSize: 0,
      // props.pageSize ?? 15,
      currentPage: 1 //props.currentPage ?? 1,
      // filter_group: props.filterId ?? 1

    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only'
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useQuery2 = useQuery(getCmsPageMeta, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
    variables: {
      filters: {
        url_key: {
          eq: 'collections'
        }
      }
    }
  }),
      categoryLoading = _useQuery2.loading,
      categoryError = _useQuery2.error,
      categoryData = _useQuery2.data;

  var category = categoryData !== null && categoryData !== void 0 && (_categoryData$categor = categoryData.categories) !== null && _categoryData$categor !== void 0 && (_categoryData$categor2 = _categoryData$categor.items) !== null && _categoryData$categor2 !== void 0 && _categoryData$categor2[0] ? categoryData === null || categoryData === void 0 ? void 0 : (_categoryData$categor3 = categoryData.categories) === null || _categoryData$categor3 === void 0 ? void 0 : (_categoryData$categor4 = _categoryData$categor3.items) === null || _categoryData$categor4 === void 0 ? void 0 : _categoryData$categor4[0] : undefined;
  return {
    loading: loading,
    error: error,
    collections: data === null || data === void 0 ? void 0 : (_data$collections = data.collections) === null || _data$collections === void 0 ? void 0 : _data$collections.collections,
    // totalCollections: data?.collections?.collection_size,
    // totalPages: Math.ceil(data?.collections?.collection_size / props.pageSize),
    category: category
  };
};